import { render } from "./ShopWrapper.vue?vue&type=template&id=93765daa&scoped=true"
import script from "./ShopWrapper.vue?vue&type=script&lang=js"
export * from "./ShopWrapper.vue?vue&type=script&lang=js"

import "./ShopWrapper.vue?vue&type=style&index=0&id=93765daa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93765daa"]])

export default __exports__